/**
 * @description ### Returns Go / Lua like responses(data, err)
 * when used with await
 *
 * - Example response { data, undefined }
 * - Example response { undefined, Error }
 *
 *
 * When used with Promise.all([req1, req2, req3])
 * - Example response { {data: {data1, data2, data3}}, undefined }
 * - Example response { undefined, Error }
 *
 *
 * When used with Promise.race({req1, req2, req3])
 * - Example response { data, undefined }
 * - Example response { undefined, Error }
 *
 * @param {Promise} promise
 * @returns {{data : undefined |  any, err: Error |  undefined}} { data, err }
 */
export const goAsync = (promise) => {
  // @ts-ignore
  return promise
    .then((data) => {
      return { data: data, err: undefined };
    })
    .catch((err) => {
      return { data: undefined, err: err || true };
    });
};
